<template>
    <div class="fw-login">
        <div class="login-tb">
            <img src="../../assets/loginbt.png" class="lbt-sp"/>
        </div>
        <div class="login-cmn">
            <div class="login-content">
                <div style="display:flex;flex-direction: column;width: 75%;margin: auto">
                    <van-cell-group style="width: 100%;" :border="false">
                        <van-field
                                left-icon="shop"
                                v-model="mdName"
                                label-width="50px"
                                placeholder="请输入店名"
                        />
                    </van-cell-group>
                    <van-cell-group style="width: 100%;" :border="false">
                        <van-field
                                left-icon="invitation"
                                v-model="industry"
                                label-width="50px"
                                placeholder="请输入行业"
                        />
                    </van-cell-group>
                    <van-cell-group style="width: 100%;" :border="false">
                        <van-field
                                left-icon="map-marked"
                                v-model="address"
                                label-width="50px"
                                placeholder="请输入地址"
                        />
                    </van-cell-group>
                    <van-cell-group style="width: 100%;" :border="false">
                        <van-field
                                left-icon="contact"
                                v-model="fullName"
                                label-width="50px"
                                placeholder="请输入姓名"
                        />
                    </van-cell-group>
                    <van-cell-group style="width: 100%;" :border="false">
                        <van-field
                                left-icon="phone"
                                v-model="phone"
                                label-width="50px"
                                placeholder="请输入手机号"
                        />
                    </van-cell-group>
                </div>
            </div>
            <div style="text-align: center;width: 75%;margin: auto;">
                <van-button type="primary" :loading="loading"  style="width: 100%;" @click="toKt">预约开通</van-button>
                <van-button type="primary" style="width: 100%;" @click="fanhui">返 回</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mdName: '',
                industry:'',
                address:'',
                fullName:'',
                phone:'',
                loading:false,
                deptId:'',
                deptName:'',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.deptId=this.$route.query.deptId
            this.deptName=this.$route.query.deptName
        },
        methods: {
            async toKt() {
                if (!this.mdName){
                    this.$notify({type: 'danger', message: '请填写门店'});
                    return ;
                }
                if (!this.industry){
                    this.$notify({type: 'danger', message: '请填写行业'});
                    return ;
                }
                if (!this.address){
                    this.$notify({type: 'danger', message: '请填写地址'});
                    return ;
                }
                if (!this.fullName){
                    this.$notify({type: 'danger', message: '请填写姓名'});
                    return ;
                }
                if (!this.phone){
                    this.$notify({type: 'danger', message: '请填写手机号'});
                    return ;
                }
                this.loading=true
                let data={
                    mdName: this.mdName,
                    industry: this.industry,
                    address: this.address,
                    fullName: this.fullName,
                    phone: this.phone,
                    superiorId: this.deptId,
                    deptName: this.deptName,
                }
                let res = await this.$post("/fw/saveSysVisiting", data)
                if (res.code == 200) {
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.loading=false
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            fanhui(){
                this.$router.go(-1)
            },
            toHome(){
                this.$router.push('/home')
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-login {
        margin: 0 auto;
        height: 100%;
        background: url(../../assets/login.jpg);
        background-size: 100% 100%;
        position: relative;
    }

    .login-tb {
        height: 30%;
        padding-top: 30%;
    }

    .lbt-sp {
        width: 60%;
        margin: auto;
        font-size: 26px;
        display: block;
        text-align: center
    }

    .login-cmn {
        width: 100%;
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .login-content {
        padding-top: 25px;
        padding-bottom: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .van-button {
        height: 32px;
        border-radius: 35px;
    }

    .van-button--primary {
        color: #fff;
        background-color: #FA7298;
        border: 1px solid #FA7298;
        height: 38px;
    }

    .van-cell-group {
        background-color: transparent;
        margin-bottom: 12px;
    }

    .van-cell {
        position: relative;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 8px 12px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.60rem;
    }
    /*::v-deep .van-field__label {*/
    /*    -webkit-box-flex: 0;*/
    /*    -webkit-flex: none;*/
    /*    -ms-flex: none;*/
    /*    flex: none;*/
    /*    box-sizing: border-box;*/
    /*    width: 6.2em;*/
    /*    margin-right: 0.32rem;*/
    /*    color: #646566;*/
    /*    text-align: left;*/
    /*    word-wrap: break-word;*/
    /*    border-left: silver solid 1px;*/
    /*    margin-left: 8px;*/
    /*    padding-left: 10px;*/
    /*}*/
    ::v-deep .van-field__control {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 0;
        color: #323233;
        line-height: inherit;
        text-align: left;
        background-color: transparent;
        border: 0;
        resize: none;
        border-left: silver solid 1px;
        margin-left: 8px;
        padding-left: 10px;
    }
    /*::v-deep .el-input .el-input__inner {*/
    /*    background-color: transparent;*/
    /*    border-radius: 0px;*/
    /*    color: #323233;*/

    /*}*/


    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }
</style>
